import React from "react";
import styled from "styled-components";
import { CheckCircleFilled } from "@ant-design/icons";

const Section = styled.div`
  padding: 64px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 48px;
`;

const Phones = styled.div`
  display: flex;
  gap: 16px;
  flex: 1;
  justify-content: center;

  img {
    max-height: 400px;
    object-fit: contain;
  }
`;

const Content = styled.div`
  flex: 1;
  max-width: 500px;

  h2 {
    font-size: 24px;
    margin-bottom: 16px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin-bottom: 24px;

    li {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 12px;
      font-size: 15px;

      svg {
        color: #10b981;
        font-size: 16px;
      }
    }
  }

  .store-buttons {
    display: flex;
    gap: 12px;

    img {
      height: 42px;
      cursor: pointer;
    }
  }
`;

const AppExperience = () => {
  return (
    <Section>
      <Phones>
        <img
          src="https://cdn.dribbble.com/userupload/36088696/file/original-107166322a0110dd9b3e9a4b4d8490b3.png"
          alt="App Screenshot 1"
        />
      </Phones>

      <Content>
        <h2>A best-in-class experience</h2>
        <p>
          iOS and Android apps provide a seamless apartment search experience.
        </p>

        <ul>
          <li>
            <CheckCircleFilled /> Extensive filters to refine your search
          </li>
          <li>
            <CheckCircleFilled /> Tailored recommendations
          </li>
          <li>
            <CheckCircleFilled /> Alerts for pricing and availability
          </li>
          <li>
            <CheckCircleFilled /> Digital tours and applications
          </li>
        </ul>

        <div className="store-buttons">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0eOmm8lR_dgM2e5hko5IWEPgFeG5HtLYU1A&s"
            alt="App Store"
          />
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR7cDenJxJECrEs_tf7Q_egOsRFU0VOIFzlLw&s"
            alt="Google Play"
          />
        </div>
      </Content>
    </Section>
  );
};

export default AppExperience;
